import { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import api from '../../api/axios';

export default function PasswordRecovery({ reset = false }) {
  const [params] = useSearchParams();
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const token = params.get('token');
  async function submit(event) {
    event.preventDefault(); setError(''); setMessage('');
    if (reset && password !== confirmation) { setError('تکرار رمز عبور مطابقت ندارد.'); return; }
    setBusy(true);
    try {
      const response = await api.post(`/api/admin/${reset ? 'reset-password' : 'forgot-password'}`, reset ? { token, password } : { identifier });
      setMessage(response.data.message); setDone(true);
      if (reset) window.history.replaceState(null, '', window.location.pathname);
    } catch (err) { setError(err.response?.data?.message || 'ارتباط با سرور برقرار نشد. دوباره تلاش کنید.'); }
    finally { setBusy(false); }
  }
  return <main dir="rtl" className="flex min-h-screen items-center justify-center bg-[#f3efe7] p-5">
    <form onSubmit={submit} className="admin-surface w-full max-w-md space-y-5 p-8">
      <p className="admin-kicker">AZI ADMIN</p>
      <h1 className="admin-title">{reset ? 'رمز عبور جدید' : 'بازیابی رمز عبور'}</h1>
      <p className="text-sm leading-7 text-[#6f7b76]">{reset ? 'رمزی با حداقل ۱۲ کاراکتر انتخاب کنید.' : 'نام کاربری یا ایمیل مدیر را وارد کنید تا لینک بازیابی برای ایمیل ثبت‌شده ارسال شود.'}</p>
      {!done && (reset ? <>
        <label className="block">رمز جدید<input className="admin-field mt-2" type="password" autoComplete="new-password" minLength={12} required value={password} onChange={e => setPassword(e.target.value)} /></label>
        <label className="block">تکرار رمز جدید<input className="admin-field mt-2" type="password" autoComplete="new-password" minLength={12} required value={confirmation} onChange={e => setConfirmation(e.target.value)} /></label>
      </> : <label className="block">نام کاربری یا ایمیل<input className="admin-field mt-2" dir="ltr" autoComplete="username" required value={identifier} onChange={e => setIdentifier(e.target.value)} /></label>)}
      {reset && !token && !done && <p role="alert">لینک بازیابی نامعتبر است. لینک جدید درخواست کنید.</p>}
      {error && <p role="alert" className="text-sm text-red-700">{error}</p>}
      {message && <p role="status" className="text-sm leading-7 text-[#1c2c29]">{message}</p>}
      {!done && <button className="admin-primary w-full disabled:opacity-50" disabled={busy || (reset && !token)}>{busy ? 'در حال پردازش…' : reset ? 'ذخیره رمز جدید' : 'ارسال لینک بازیابی'}</button>}
      <Link className="block text-center text-sm underline" to="/login">بازگشت به ورود</Link>
      {reset && !done && <Link className="block text-center text-sm underline" to="/forgot-password">درخواست لینک جدید</Link>}
    </form>
  </main>;
}
